<div class="search-mobile" [class.animted]="show">
  <div class="search-input">
    <img src="assets/icons/search.svg" alt="search icon">
    <ng-content select="[query]"></ng-content>
  </div>
  <div class="search-input">
    <img src="assets/icons/calendar.svg" alt="calendar icon">
    <ng-content select="[date]"></ng-content>
  </div>
  <div class="search-input">
    <img src="assets/icons/location-outline.svg" alt="location icon">
    <ng-content select="[location]"></ng-content>
  </div>

  <ng-content select="[action]"></ng-content>
</div>
